export function cssValue(property) {
  return getComputedStyle(document.documentElement)
    .getPropertyValue(property);
}